export default __webpack_public_path__ + "static/media/tcm_full.54284c6e.jpg";